import axios from "axios";
import { useState, useRef } from "react";
import moment from "moment-timezone";
import cookieStorage from "../cookieStorage";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function useApi() {
    const [product, setProduct] = useState({});
    const [products, setProducts] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [searchProducts, setSearchProducts] = useState([]);
    const [cart, setCart] = useState({});
    const [cartTimeReset, setCartTimeReset] = useState(false);
    const [dontShowTimeExtendAlert, setDontShowTimeExtendAlert] = useState(
        false
    );
    const [orders, setOrders] = useState([]);
    const [order, setOrder] = useState({});
    const [customer, setCustomer] = useState({});
    const [customerRewardItem, setCustomerRewardItem] = useState();
    const [cartTime, setCartTime] = useState(0);
    const [cartProducts, setCartProducts] = useState({});
    const [productByBatch, setProductByBatch] = useState({});
    const [pricing, setPricing] = useState(null);
    const [linePricingByProductId, setLinePricingByProductId] = useState({});
    const [productCache, setProductCache] = useState({}); // simple ID -> data cache
    const [orderCache, setOrderCache] = useState({}); // orderNumber -> data cache
    const [orderIdCache, setOrderIdCache] = useState({}); // mongoId -> data cache
    const [invoiceCache, setInvoiceCache] = useState({}); // invoiceId -> data cache
    const pendingRequests = useRef(new Map());
    const [similar, setSimilar] = useState([]);
    const [favorite, setFavorite] = useState({});
    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState({});
    const [availabilityFilters, setAvailabilityFilters] = useState([]);
    const [categoryFilters, setCategoryFilters] = useState([]);
    const [brandFilters, setBrandFilters] = useState([]);
    const [phenotypes, setPhenotypes] = useState([]);
    const [phenotypeFilters, setPhenotypeFilters] = useState([]);
    const [tastes, setTastes] = useState([]);
    const [tasteFilters, setTasteFilters] = useState([]);
    const [terpines, setTerpines] = useState([]);
    const [effects, setEffects] = useState([]);
    const [effectFilters, setEffectFilters] = useState([]);
    const [terpineFilters, setTerpineFilters] = useState([]);
    const [subFilters, setSubFilters] = useState([]);
    const [deliveries, setDeliveries] = useState([]);
    const [delivery, setDelivery] = useState({});
    const [favoriteProducts, setFavoriteProducts] = useState({});
    const [newsletter, setNewsletter] = useState({});
    const [cartAmount, setCartAmount] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [originalPrice, setOriginalPrice] = useState(0);
    const [updating, setUpdating] = useState(false);
    const [ordering, setOrdering] = useState(false);
    const [showGamificationPopOver, setShowGamificationPopOver] = useState(
        false
    );

    const [rewards, setRewards] = useState(
        cookieStorage.getItem("rewards")
            ? JSON.parse(cookieStorage.getItem("rewards"))
            : []
    );
    const [rewardsThreshold, setRewardsThreshold] = useState(
        cookieStorage.getItem("rewardsThreshold")
            ? JSON.parse(cookieStorage.getItem("rewardsThreshold"))
            : null
    );
    const [userId, setUserId] = useState(
        cookieStorage.getItem("userId") ? cookieStorage.getItem("userId") : null
    );
    const [priceClass, setPriceClass] = useState(
        cookieStorage.getItem("priceClass")
            ? cookieStorage.getItem("priceClass")
            : null
    );
    const [priceid, setPriceid] = useState(
        cookieStorage.getItem("priceid") ? cookieStorage.getItem("priceid") : null
    );
    const [customerId, setCustomerId] = useState(
        cookieStorage.getItem("customerId")
            ? cookieStorage.getItem("customerId")
            : null
    );
    const [accessToken, setAccessToken] = useState(
        cookieStorage.getItem("accessToken")
            ? cookieStorage.getItem("accessToken")
            : null
    );
    const [isAdmin, setIsAdmin] = useState(
        cookieStorage.getItem("isAdmin")
            ? cookieStorage.getItem("isAdmin")
            : false
    );
    const [firstLogin, setFirstLogin] = useState(
        cookieStorage.getItem("firstLogin")
            ? JSON.parse(cookieStorage.getItem("firstLogin"))
            : false
    );
    const [childCustomers, setChildCustomers] = useState(
        cookieStorage.getItem("childCustomers")
            ? JSON.parse(cookieStorage.getItem("childCustomers"))
            : []
    );
    const [multipleCustomers, setMultipleCustomers] = useState(false);
    const [cartOpen, setCartOpen] = useState(false);
    const headers = accessToken
        ? {
            token: `Bearer ${accessToken}`,
            priceClass: priceClass ? priceClass : "",
            priceid: priceid ? priceid : null
        }
        : {};

    const convertIntoNumber = (cartSessionTime) => {
        const actualReserveTime = 60 * 30;
        const timeDiff = moment().diff(cartSessionTime, "seconds");
        return actualReserveTime - timeDiff > 0
            ? actualReserveTime - timeDiff
            : 0;
    };
    const [openInvoices, setOpenInvoices] = useState([]);
    return {
        order,
        cart,
        orders,
        userId,
        isAdmin,
        cartAmount,
        cartTime,
        dontShowTimeExtendAlert,
        setDontShowTimeExtendAlert,
        accessToken,
        cartOpen,
        favorite,
        favoriteProducts,
        searchProducts,
        setSearchProducts,
        searchText,
        setSearchText,
        product,
        products,
        setProducts,
        cartProducts,
        productByBatch,
        brands,
        setBrands,
        pricing,
        linePricingByProductId,
        setLinePricingByProductId,
        updating,
        customer,
        setCustomerId,
        categories,
        availabilityFilters,
        categoryFilters,
        brandFilters,
        effectFilters,
        phenotypeFilters,
        tasteFilters,
        terpineFilters,
        phenotypes,
        tastes,
        deliveries,
        delivery,
        childCustomers,
        multipleCustomers,
        priceClass,
        terpines,
        effects,
        similar,
        customerId,
        newsletter,
        subFilters,
        firstLogin,
        setFirstLogin,
        setUpdating,
        setCartAmount,
        totalPrice,
        setTotalPrice,
        originalPrice,
        setOriginalPrice,
        setCartOpen,
        setAvailabilityFilters,
        setCategoryFilters,
        setBrandFilters,
        setEffectFilters,
        setPhenotypeFilters,
        setTasteFilters,
        setSubFilters,
        setTerpineFilters,
        setMultipleCustomers,
        rewardsThreshold,
        rewards,
        customerRewardItem,
        setCustomerRewardItem,
        setCart,
        setCartTime,
        setCartTimeReset,
        cartTimeReset,
        showGamificationPopOver,
        setShowGamificationPopOver,
        setOrdering,
        ordering,
        openInvoices,
        setOpenInvoices,
        login(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/auth/login`, data)
                    .then((response) => {
                        resolve(response.data);
                        setUserId(response.data._id);
                        setAccessToken(response.data.accessToken);
                        setCustomerId(response.data.customerId);
                        if (response.data.childCustomers.length > 0) {
                            setCustomerId(
                                response.data.childCustomers[0].customerId
                            );
                        }
                        setIsAdmin(response.data.isAdmin);
                        setCustomer(response.data.customer);
                        setPriceClass(response.data.customer.PriceClassID);
                        setPriceid(response.data.customerId);
                        setFirstLogin(true);
                        setRewards(response.data.rewards);
                        setChildCustomers(response.data.childCustomers);
                        if (response.data.customerRewardsThreshold) {
                            const formattedData = {
                                threshold1:
                                    response.data.customerRewardsThreshold
                                        .Threshold1.value,
                                threshold2:
                                    response.data.customerRewardsThreshold
                                        .Threshold2.value,
                                threshold3:
                                    response.data.customerRewardsThreshold
                                        .Threshold3.value
                            };
                            setRewardsThreshold(formattedData);
                            cookieStorage.setItem(
                                "rewardsThreshold",
                                JSON.stringify(formattedData)
                            );
                        } else {
                            cookieStorage.setItem("rewardsThreshold", null);
                        }

                        cookieStorage.setItem("userId", response.data._id);
                        cookieStorage.setItem(
                            "accessToken",
                            response.data.accessToken
                        );
                        cookieStorage.setItem(
                            "customerId",
                            response.data.customerId
                        );
                        cookieStorage.setItem(
                            "rewards",
                            JSON.stringify(response.data.rewards)
                        );
                        if (response.data.childCustomers.length > 0) {
                            cookieStorage.setItem(
                                "customerId",
                                response.data.childCustomers[0].customerId
                            );
                        }
                        cookieStorage.setItem("isAdmin", response.data.isAdmin);
                        cookieStorage.setItem(
                            "priceClass",
                            response.data.customer.PriceClassID
                        );
                        cookieStorage.setItem(
                            "priceid",
                            response.data.customerId
                        );
                        cookieStorage.setItem("firstLogin", true);
                        cookieStorage.setItem(
                            "childCustomers",
                            JSON.stringify(response.data.childCustomers)
                        );
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        logout() {
            return new Promise((res) => {
                // Clear state variables to prevent background tasks from re-populating cookies
                setUserId(null);
                setAccessToken(null);
                setCustomerId(null);
                setPriceClass(null);
                setPriceid(null);
                setIsAdmin(false);
                setCustomer({});
                setChildCustomers([]);
                setRewards([]);
                setRewardsThreshold(null);
                setFirstLogin(false);
                setCart({});
                setCartProducts({});

                // Clear all persistent storage
                cookieStorage.removeItem("userId");
                cookieStorage.removeItem("accessToken");
                cookieStorage.removeItem("isAdmin");
                cookieStorage.removeItem("priceClass");
                cookieStorage.removeItem("priceid");
                cookieStorage.removeItem("rewardsThreshold");
                cookieStorage.removeItem("countdownTime");
                cookieStorage.removeItem("customerId");
                cookieStorage.removeItem("isTileView");
                cookieStorage.removeItem("firstLogin");
                cookieStorage.removeItem("childCustomers");
                cookieStorage.removeItem("rewards");

                res();
            });
        },
        register(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/auth/register`, data)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        forgot(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/auth/forgot`, data)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        request(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/auth/request`, data)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getProducts(
            availability,
            brands,
            categories,
            subCategories,
            tastes,
            terpines,
            phenotypes,
            effects,
            sort,
            pageNum,
            pageLimit
        ) {
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        `${API_ENDPOINT}/collections?page=${pageNum}&size=${pageLimit}&brands=${encodeURIComponent(brands.toString())}&categories=${categories.toString()}&subcategories=${subCategories.toString()}&tastes=${tastes}&terpines=${terpines}&phenotypes=${phenotypes}&effects=${effects}&sort=${sort}&availability=${availability}`,
                        { headers }
                    )
                    .then((response) => {
                        resolve(response.data);
                        const actualProducts =
                            pageNum === 1
                                ? response.data.products
                                : [...products, ...response.data.products];
                        setProducts(actualProducts);
                        setCategories(response.data.categories);
                        setPhenotypes(response.data.phenotypes);
                        setTerpines(response.data.terpines);
                        setTastes(response.data.tastes);
                        setEffects(response.data.effects);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getProductsCategories() {
            const url = `${API_ENDPOINT}/productCategories`;

            // Return cached data if available
            if (Object.keys(categories).length > 0) {
                return Promise.resolve({ categories, phenotypes });
            }

            if (pendingRequests.current.has(url)) {
                return pendingRequests.current.get(url);
            }

            const promise = new Promise((resolve, reject) => {
                axios
                    .get(url, { headers })
                    .then((response) => {
                        setCategories(response.data.categories);
                        setPhenotypes(response.data.phenotypes);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    })
                    .finally(() => {
                        pendingRequests.current.delete(url);
                    });
            });

            pendingRequests.current.set(url, promise);
            return promise;
        },
        getProductsByAvailability(availability) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/${availability}`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getNewRelease() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/new-release`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getFastMovers() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/fast-movers`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getProductsByTitle(title) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/collections/title/${title}`, {
                        headers
                    })
                    .then((response) => {
                        resolve(response.data);
                        setSearchProducts(response.data.products);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getProduct(id) {
            return new Promise((resolve, reject) => {
                // Return cached data if available for instant response
                if (productCache[id]) {
                    setProduct(productCache[id].product);
                    setSimilar(productCache[id].similarProducts);
                    resolve(productCache[id]);
                    // We still re-fetch in the background to ensure data is fresh (Stale-While-Revalidate pattern)
                }

                axios
                    .get(`${API_ENDPOINT}/products/${id}`, { headers })
                    .then((response) => {
                        setProduct(response.data.product);
                        setSimilar(response.data.similarProducts);
                        setProductCache((prev) => ({
                            ...prev,
                            [id]: response.data
                        }));
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response?.data || error.message);
                    });
            });
        },
        getProductInventory(id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/products/handle/${id}`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getCart(id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/carts/${id}`, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setCart(response.data.cart);
                        setCartProducts(response.data.cartProducts);
                        setProductByBatch(response.data.productByBatch);
                        setPricing(response.data.pricing || null);
                        setLinePricingByProductId(response.data.linePricingByProductId || {});
                        if (response.data.pricing) {
                            setTotalPrice(response.data.pricing.total || 0);
                            setOriginalPrice(response.data.pricing.subtotal || 0);
                        }
                        setCartTime(
                            convertIntoNumber(response.data.cart.SessionTime)
                        );
                    })
                    .catch((error) => {
                        // reject(error.response.data);
                        setCart({});
                        setCartProducts({});
                        setProductByBatch({});
                        setPricing(null);
                        setLinePricingByProductId({});
                        setCartAmount(0);
                    });
            });
        },
        addCart(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/carts`, data, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setCart(response.data.savedCart);
                        setCartProducts(response.data.cartProducts);
                        setProductByBatch(response.data.productByBatch);
                        setPricing(response.data.pricing || null);
                        setLinePricingByProductId(response.data.linePricingByProductId || {});
                        if (response.data.pricing) {
                            setTotalPrice(response.data.pricing.total || 0);
                            setOriginalPrice(response.data.pricing.subtotal || 0);
                        }
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        updateCart(id, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${API_ENDPOINT}/carts/${id}`, data, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setCart(response.data.updatedCart);
                        setCartProducts(response.data.cartProducts);
                        setProductByBatch(response.data.productByBatch);
                        setPricing(response.data.pricing || null);
                        setLinePricingByProductId(response.data.linePricingByProductId || {});
                        if (response.data.pricing) {
                            setTotalPrice(response.data.pricing.total || 0);
                            setOriginalPrice(response.data.pricing.subtotal || 0);
                        }
                        setCartTime(
                            convertIntoNumber(
                                response.data.updatedCart.SessionTime
                            )
                        );
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        removeCart(id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`${API_ENDPOINT}/carts/${id}`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getFavorite(id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/favorites/${id}`, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setFavorite(response.data.favorite);
                        setFavoriteProducts(response.data.favoriteProducts);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                        setFavorite({});
                        setFavoriteProducts({});
                    });
            });
        },
        addFavorite(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/favorites`, data, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setFavorite(response.data.savedFavorite);
                        setFavoriteProducts(response.data.favoriteProducts);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        updateFavorite(id, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${API_ENDPOINT}/favorites/${id}`, data, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setFavorite(response.data.updatedFavorite);
                        setFavoriteProducts(response.data.favoriteProducts);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        addOrder(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/orders`, data, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        applyDiscount(customerId, discountCode) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/orders/${customerId}/applyDiscount`, { discountCode }, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getOrdersByCustomerId(id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/orders/${id}`, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setOrders(response.data.orders);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getOrder(id) {
            const url = `${API_ENDPOINT}/orders/order/${id}`;

            if (orderIdCache[id]) {
                return Promise.resolve({ order: orderIdCache[id] });
            }

            if (pendingRequests.current.has(url)) {
                return pendingRequests.current.get(url);
            }

            const promise = new Promise((resolve, reject) => {
                axios
                    .get(url, { headers })
                    .then((response) => {
                        if (response.data.order) {
                            const orderData = response.data.order;
                            setOrderIdCache(prev => ({ ...prev, [id]: orderData }));
                            if (orderData.OrderNbr?.value) {
                                setOrderCache(prev => ({ ...prev, [orderData.OrderNbr.value]: orderData }));
                            }
                        }
                        resolve(response.data);
                        setOrder(response.data.order);
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    })
                    .finally(() => {
                        pendingRequests.current.delete(url);
                    });
            });

            pendingRequests.current.set(url, promise);
            return promise;
        },

        getOrderByOrderNumber(orderNumber) {
            const url = `${API_ENDPOINT}/orders/orderNumber/${orderNumber}`;

            if (orderCache[orderNumber]) {
                return Promise.resolve({ order: orderCache[orderNumber] });
            }

            if (pendingRequests.current.has(url)) {
                return pendingRequests.current.get(url);
            }

            const promise = new Promise((resolve, reject) => {
                axios
                    .get(url, { headers })
                    .then((response) => {
                        if (response.data.order) {
                            setOrderCache(prev => ({ ...prev, [orderNumber]: response.data.order }));
                        }
                        resolve(response.data);
                        setOrder(response.data.order);
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    })
                    .finally(() => {
                        pendingRequests.current.delete(url);
                    });
            });

            pendingRequests.current.set(url, promise);
            return promise;
        },
        getCustomer(id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/customers/${id}`, { headers })
                    .then((response) => {
                        const customerData = response.data.customer || {};
                        const shippingZoneId = typeof customerData.ShippingZoneID === "string"
                            ? customerData.ShippingZoneID
                            : customerData.ShippingZoneID?.value || "";
                        const normalizedCustomer = {
                            ...customerData,
                            ShippingZoneID: shippingZoneId
                        };
                        const normalizedResponse = {
                            ...response.data,
                            customer: normalizedCustomer
                        };

                        resolve(normalizedResponse);
                        setCustomer(normalizedCustomer);
                        setRewards(response.data.rewards);
                        setIsAdmin(response.data.isAdmin);

                        setPriceid(id);
                        if (response.data.customerRewardsThreshold) {
                            const formattedData = {
                                threshold1:
                                    response.data.customerRewardsThreshold
                                        .Threshold1.value,
                                threshold2:
                                    response.data.customerRewardsThreshold
                                        .Threshold2.value,
                                threshold3:
                                    response.data.customerRewardsThreshold
                                        .Threshold3.value
                            };
                            setRewardsThreshold(formattedData);
                            cookieStorage.setItem(
                                "rewardsThreshold",
                                JSON.stringify(formattedData)
                            );
                            cookieStorage.setItem(
                                "rewards",
                                JSON.stringify(response.data.rewards)
                            );
                        } else {
                            setRewardsThreshold(null);
                            cookieStorage.setItem("rewardsThreshold", null);
                        }
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },
        getCustomerRewards() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/rewards?customerId=${customerId}`, {
                        headers
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getNewsletter() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/newsletter`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        getBanners() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/contents/banners`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
            });
        },
        updateNewsletter(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/newsletter`, data, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setNewsletter(response.data.updatedNewsletter.banners);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getContents() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/contents`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        getDeliveries() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/delivery`, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setDeliveries(response.data.deliveries);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getDelivery(id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/delivery/${id}`, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setDelivery(response.data.delivery);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        addDelivery(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/delivery`, data, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setDelivery(response.data.savedDelivery);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        rebuildCart(id) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `${API_ENDPOINT}/carts/${id}/${customerId}/rebuildCart`,
                        {},
                        { headers }
                    )
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        getSimilarProducts(productId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/${productId}/similiarProducts`, {
                        headers
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        reviewOrder() {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `${API_ENDPOINT}/orders/${customerId}/reviewOrder`,
                        {},
                        { headers }
                    )
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        extendCartTime() {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${API_ENDPOINT}/carts/${customerId}/addTime`, "", {
                        headers
                    })
                    .then((response) => {
                        resolve(response.data);
                        setCartTime(
                            convertIntoNumber(response.data.SessionTime)
                        );
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        updateDelivery(id, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${API_ENDPOINT}/delivery/${id}`, data, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setDelivery(response.data.updatedDelivery);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getCutoff() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/delivery/cutoff/update`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        updateCutoff(data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${API_ENDPOINT}/delivery/cutoff/update`, data, {
                        headers
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        removeDelivery(id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`${API_ENDPOINT}/delivery/${id}`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        getAllBrands() {
            const url = `${API_ENDPOINT}/brands`;
            if (pendingRequests.current.has(url)) {
                return pendingRequests.current.get(url);
            }

            const promise = new Promise((resolve, reject) => {
                axios
                    .get(url, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    })
                    .finally(() => {
                        pendingRequests.current.delete(url);
                    });
            });

            pendingRequests.current.set(url, promise);
            return promise;
        },

        addPickUpPayment(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/pickup-payment`, data, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    });
            });
        },

        updateCustomer(id, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${API_ENDPOINT}/auth/update-profile/${id}`, data, { headers })
                    .then((response) => {
                        resolve(response.data);
                        if (response.data.customer) {
                            setCustomer(response.data.customer);
                        }
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    });
            });
        },

        updatePassword(id, passwordData) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/auth/change-password/${id}`, passwordData, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    });
            });
        },

        resetPassword(passwordData) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/auth/reset-password`, passwordData)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    });
            });
        },
        getAllDetailsOfProducts() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/alldetailsOfProducts`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        getOpenInvoices(customerId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/open-invoices/get-open-invoices-by-customer/${customerId}`, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setOpenInvoices(response.data.openInvoices);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        getOpenInvoiceByInvoiceId(invoiceId) {
            const url = `${API_ENDPOINT}/open-invoices/get-open-invoice-by-id/${invoiceId}`;

            if (invoiceCache[invoiceId]) {
                return Promise.resolve(invoiceCache[invoiceId]);
            }

            if (pendingRequests.current.has(url)) {
                return pendingRequests.current.get(url);
            }

            const promise = new Promise((resolve, reject) => {
                axios
                    .get(url, { headers })
                    .then((response) => {
                        setInvoiceCache(prev => ({ ...prev, [invoiceId]: response.data }));
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    })
                    .finally(() => {
                        pendingRequests.current.delete(url);
                    });
            });

            pendingRequests.current.set(url, promise);
            return promise;
        },

        updateOrCreateContent(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/contents`, data, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        getContentById(id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/contents/${id}`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        getAllCustomer() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/customers`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        deleteContent(contentId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`${API_ENDPOINT}/contents/${contentId}`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        getSpotLightProduct() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/contents/spotlight`, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },

        getProductByContent(contentId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/contents/product-by-content/${contentId}`, { headers })
                    .then((response) => {
                        resolve(response.data);
                        setProducts(response.data.products);

                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        reschedulePaymentPickup(id, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${API_ENDPOINT}/pickup-payment/${id}`, data, { headers })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    });
            });
        },
    };
}
